import { Permission, Role } from '../types';

// Функция для перевода прав на русский язык
export const translatePermission = (permission: Permission): string => {
  const translations: Record<string, string> = {
    // Admin permissions
    'admin_create': 'Создание администраторов',
    'admin_read': 'Просмотр администраторов',
    'admin_update': 'Редактирование администраторов',
    'admin_delete': 'Удаление администраторов',
    
    // Category permissions
    'category_create': 'Создание категорий',
    'category_read': 'Просмотр категорий',
    'category_update': 'Редактирование категорий',
    'category_delete': 'Удаление категорий',
    
    // Post permissions
    'post_create': 'Создание постов',
    'post_read': 'Просмотр постов',
    'post_update': 'Редактирование постов',
    'post_delete': 'Удаление постов',
    'post_publish': 'Публикация постов',
    
    // Role permissions
    'role_create': 'Создание ролей',
    'role_read': 'Просмотр ролей',
    'role_update': 'Редактирование ролей',
    'role_delete': 'Удаление ролей',
    
    // Permission permissions
    'permission_create': 'Создание прав',
    'permission_read': 'Просмотр прав',
    'permission_update': 'Редактирование прав',
    'permission_delete': 'Удаление прав',
    // Session and profile permissions
    'sessions_read': 'Просмотр сессий',
    'sessions_terminate': 'Завершение сессий',
    'profile_update': 'Изменение профиля',
    slider_create: 'Создание слайдов',
    slider_read: 'Просмотр слайдов',
    slider_update: 'Редактирование слайдов',
    slider_delete: 'Удаление слайдов',
    slider_category_create: 'Создание категорий слайдера',
    slider_category_read: 'Просмотр категорий слайдера',
    slider_category_update: 'Редактирование категорий слайдера',
    slider_category_delete: 'Удаление категорий слайдера',
  };
  
  return translations[permission.name] || permission.name;
};

// Функция для перевода ролей на русский язык
export const translateRole = (role: Role): string => {
  const translations: Record<string, string> = {
    'super_admin': 'Супер администратор',
    'admin': 'Администратор',
    'editor': 'Редактор',
    'viewer': 'Просмотр',
  };
  
  return translations[role.name] || role.name;
}; 